import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import { fetchJson } from "../utils/fetchJson";

export default function PublisherPage() {
    const { key } = useParams();
    console.log('key', key)
    const [menu, setMenu] = useState([]);
    const [data, setData] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        getMenu();
    }, []);

    useEffect(() => {
        if (key) {
            getContent(key);
        }
    }, [key]);
    const getMenu = () => {
        fetchJson("/json/publisherMenu.json")
            .then((response) => response.json())
            .then((data) => setMenu(data))
            .catch((error) => console.error("menu:", error));
    };

    const getContent = (key) => {
        fetchJson(`/json/publisher/${key}.json`)
            .then((response) => response.json())
            .then((data) => setData(data))
            .catch((error) => console.error("data:", error));
    }

    return (
        <div>

            <div className="page-title">
                <h1>{data.title}</h1>
            </div>

            <Row>
                <Col xs={12} md={3}>
                    <Card
                        style={{
                            maxHeight: isMobile ? "calc(100vh - 40px)" : "calc(100vh - 100px)",
                            overflowY: "auto",
                            padding: isMobile ? "1rem" : "1.5rem",
                            position: isMobile ? "static" : "sticky",
                            top: isMobile ? "auto" : "100px",
                            left: isMobile ? "auto" : 0,
                            zIndex: 10,
                        }}
                    >
                        <Card.Header style={{
                            padding: 0,
                            borderBottom: "2px solid #3498db",
                            marginBottom: "1rem",
                            backgroundColor: "transparent",
                        }}>
                            <h3 style={{
                                color: "#2c3e50",
                                paddingBottom: "10px",
                                margin: 0,
                                fontSize: isMobile ? "1.2rem" : "1.3rem",
                            }}>
                                Overview
                            </h3>
                        </Card.Header>
                        <Card.Body style={{ padding: 0 }}>
                            <ul className="p-0">
                                {menu.map(({ id, title, link }) => (
                                    <li key={id} >
                                        <a
                                            href={link}
                                            className={`btn d-flex justify-content-between align-items-center btn-secondary`}
                                            style={{
                                                display: "block",
                                                textAlign: "left",
                                                padding: "8px 15px",
                                                borderRadius: "8px",
                                                transition: "all 0.3s ease",
                                                width: "100%",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    flexGrow: 1,
                                                    marginRight: "8px",
                                                }}
                                            >
                                                {title}
                                            </span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={9}>
                    {data.data && data.data.map((item, level = 0) => (
                        <section key={item.title} className="card mb-4 p-4"
                            style={{ marginBottom: isMobile ? "1.5rem" : "1rem" }}
                        >
                            <h2
                                className="mb-3"
                                style={{
                                    color: "#2c3e50",
                                    fontSize:
                                        level === 0
                                            ? isMobile
                                                ? "1.5rem"
                                                : "1.8rem"
                                            : isMobile
                                                ? "1.3rem"
                                                : "1.5rem",
                                    borderLeft: `4px solid ${level === 0 ? "#3498db" : "#2980b9"}`,
                                    paddingLeft: "15px",
                                    marginBottom: isMobile ? "1rem" : "0.5rem",
                                }}
                            >
                                {item.title}
                            </h2>
                            <Card.Body>
                                {/* 使用 whiteSpace: 'pre-wrap' 来完美保留 JSON 中的 \n 换行符 */}
                                <Card.Text style={{ whiteSpace: 'pre-wrap',textAlign:"justify" }}>
                                    {/* {item.desc} */}
                                    <span dangerouslySetInnerHTML={{ __html: item.desc }} />
                                </Card.Text>
                            </Card.Body>
                        </section>
                    ))}
                </Col>
            </Row>

        </div>
    );
}